export default __webpack_public_path__ + "static/media/S_CoreDream_5Medium.c2081f40.woff";